var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4177 4.37407C12.5752 3.78993 10.5835 3.89263 8.81079 4.66318C7.03813 5.43374 5.60438 6.82004 4.77463 8.56578C3.94488 10.3115 3.77523 12.2987 4.29706 14.1598C4.81889 16.0209 5.99691 17.6302 7.61331 18.6901C9.22971 19.7499 11.1752 20.1888 13.0901 19.9254C15.0049 19.662 16.7597 18.7143 18.03 17.2574C19.135 15.9899 19.8084 14.4117 19.9648 12.75H21.9719C21.8105 14.8957 20.9603 16.9398 19.5374 18.5717C17.9496 20.3928 15.7562 21.5775 13.3626 21.9067C10.969 22.236 8.53714 21.6874 6.51663 20.3626C4.49613 19.0377 3.02361 17.0261 2.37133 14.6997C1.71904 12.3733 1.93109 9.88941 2.96828 7.70723C4.00547 5.52505 5.79765 3.79217 8.01349 2.82898C10.2293 1.86579 12.719 1.73741 15.0221 2.46759C16.0695 2.79965 16.9311 3.12151 17.6819 3.65165C18.1333 3.97036 18.5206 4.34648 18.8857 4.80358L20.3331 3.35624C20.8559 2.83338 21.75 3.20369 21.75 3.94314V9.50001H16.1931C15.4537 9.50001 15.0833 8.60598 15.6062 8.08311L17.4597 6.22967C17.1376 5.79444 16.8446 5.50871 16.5284 5.28546C16.0482 4.94642 15.4431 4.69918 14.4177 4.37407Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7a68131702a1c74167645803e55b9ff7.svg";
export { ForwardRef as ReactComponent };